module.exports = __webpack_public_path__ + "img/kv_background.06de3401.png";